<template>
  <div class="wl-peixun-manager">
    <div class="wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">{{meetTitle}}</span>
        <!-- <div style="float:right;"> -->
          <el-form :inline="true">
            <el-form-item>
              <!-- <div style="width:48%;float:left">
                <el-input v-model="hotelTitle" placeholder="请输入单位" clearable></el-input>
              </div> -->
            </el-form-item>
            <el-form-item>
              <!-- <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
              <el-button type="primary" icon="el-icon-search" @click="openAddDialog">添加</el-button>
              <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
            </el-form-item>
          </el-form>
        <!-- </div> -->
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="hotelTitle" show-overflow-tooltip label="级别">
            <template slot-scope="scope" width="150">
              <span v-if="scope.row.Level==1">初级</span>
              <span v-else-if="scope.row.Level==2">中级</span>
              <span v-else-if="scope.row.Level==3">高级</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" show-overflow-tooltip label="时间">
             <template slot-scope="scope">
              <p>{{scope.row.StartTime}}-{{scope.row.EndTime}}</p>
              <p>{{scope.row.Note}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="isBreakfast" label="培训地点" show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{scope.row.SchoolTitle}}</p>
              <p>地址：{{scope.row.Address}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="isEnable" label="住宿(报到)地点" show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{scope.row.Hotel}}</p>
              <p>价格:{{scope.row.Price}}{{scope.row.Company}}</p>
              <p>地址:{{scope.row.HotelAddress}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="el-icon-edit"
                @click="openEditDialog(scope.row)"
                type="primary"
                title="修改"
              ></el-button>
              <el-button size="mini"
                        type="danger"
                        class="el-icon-delete"
                        @click="deleteHotel(scope.row.Id)"
              titlt="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination> -->
      </div>
    </div>

    <el-dialog
      :title="tosititle"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form label-width="80px" :model="form">
        <el-form-item label="级别">
          <el-select v-model="form.Level" placeholder="请选择">
            <el-option label="初级" :value="1"></el-option>
            <el-option label="中级" :value="2"></el-option>
            <el-option label="高级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="form.StartTime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="form.EndTime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.Note" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="学校">
          <el-input v-model="form.SchoolTitle" placeholder="请输入学校"></el-input>
        </el-form-item>
        <el-form-item label="学校地址">
          <el-input v-model="form.Address" placeholder="请输入学校地址"></el-input>
        </el-form-item>
        <el-form-item label="住宿酒店">
          <el-input v-model="form.Hotel" placeholder="请输入住宿酒店"></el-input>
        </el-form-item>
        <el-form-item label="价格">
          <el-input-number v-model="form.Price" :min="1" label="请输入价格"></el-input-number>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="form.Company" placeholder="请输入单位"></el-input>
        </el-form-item>
        <el-form-item label="酒店地址">
          <el-input v-model="form.HotelAddress" placeholder="请输入酒店地址"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrEditHotel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { stat } from 'fs';
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      ids: [],
      CreateDisplayName: "",
      hotelTitle:"",
      meetTitle: "",
      dialogVisible:false,
      tosititle:'',
      form:{
        Id:'',
        Level:'',
        StartTime:'',
        EndTime:'',
        SchoolTitle:'',
        Address:'',
        Hotel:'',
        Price:'',
        Company:'',
        HotelAddress:'',
        Note:''
      }
    };
  },
  props: {
    activityId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getHotelList(1);
  },
  methods: {
    getHotelList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/PeiXunPlan/getPeiXunPlan", {
          activityId: this.activityId,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.meetTitle = rst.meetTitle;
            // this.total = rst.pagination.totalCount;
            // this.pageSize = rst.pagination.pageSize;
            // this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getHotelList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getHotelList(1);
    },
    openAddDialog(){
      this.dialogVisible = true;
      this.tosititle = "添加轮次";
      this.form = {
        Id:'',
        Level:'',
        StartTime:'',
        EndTime:'',
        SchoolTitle:'',
        Address:'',
        Hotel:'',
        Price:'',
        Company:'',
        HotelAddress:'',
        Note:''
      };
    },
    addOrEditHotel(){
      var that = this;
      this.$http
        .post("/api/XOrg/PeiXunPlan/addOrEditPeiXunPlan", {
          Id:this.form.Id,
          Level:this.form.Level,
          StartTime:this.form.StartTime,
          EndTime:this.form.EndTime,
          SchoolTitle:this.form.SchoolTitle,
          Address:this.form.Address,
          Hotel:this.form.Hotel,
          Price:this.form.Price,
          Company:this.form.Company,
          HotelAddress:this.form.HotelAddress,
          Note: this.form.Note,
          ActivityId: this.activityId
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getHotelList(1);
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    handleClose(){
       this.dialogVisible = false;
    },
    openEditDialog(row){
      this.dialogVisible = true;
      this.tosititle = "修改轮次";
      this.form = {
        Id:row.Id ,
        Level:row.Level,
        StartTime:row.StartTime,
        EndTime:row.EndTime,
        SchoolTitle:row.SchoolTitle,
        Address:row.Address,
        Hotel:row.Hotel,
        Price:row.Price,
        Company:row.Company,
        HotelAddress:row.HotelAddress,
        Note:row.Note
      };
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    deleteHotel(id) {
      this.$confirm("此操作将删除该轮次, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.$http
            .post("/api/XOrg/PeiXunPlan/deletePeiXunPlan", {
              ids: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getHotelList(1);
              }else{
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getHotelList(1);
    },
    goBack() {
      this.$router.push({
        name: "tarinActivity"
      });
    },
    // 启用
    editHotelEnble(id,value){
      var that = this;
        this.$http
          .post("/api/XOrg/PeiXunPlan/editHotelEnble", {
            hotelId: id,
            isEnable: value
          })
          .then(rst => {
            if (rst.code === 1) {
              that.$message({
                message: rst.msg,
                type: "success"
              });
            }else{
              that.$message.warning(rst.msg);
            }
          });
    }
  }
};
</script>

<style lang="scss">
.wl-peixun-manager {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a{
    color: #fff;
    background: #409EFF;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
